import React, { useContext } from "react";
import { LoginContext } from "context/Auth/LoginContext";
import { Link } from "react-router-dom";
import { User } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

const AuthenticationButton = ({ onClick }) => {
  const { isLoggedIn, isVerified, user, token } = useContext(LoginContext);
  const { t } = useTranslation();

  return (
    <div>
      {isLoggedIn ? (
        <Link
          className=" text-end bg-primary text-white px-4 py-2 rounded-md text-sm uppercase flex items-center gap-2"
          to="/my-account"
          onClick={onClick}
        >
          <User size={18} />
          {user.fullName}
        </Link>
      ) : (
        <Link
          className=" text-end bg-primary text-white px-4 py-2 rounded-md text-sm uppercase flex items-center gap-2"
          to="/login"
          onClick={onClick}
        >
          <User size={18} />
          {t("common.login")}
        </Link>
      )}
    </div>
  );
};

export default AuthenticationButton;
